<template>
  <v-container class="control-content" fluid>
    <v-row>
      <v-col fluid>
        <h2 class="control-content__title">{{ $t('control.widget.embed.embed_code_title') }}</h2>
        <p class="control-content__text">{{ $t('control.widget.embed.embed_code_description') }}</p>
        <textarea class="embed-code" cols="100" rows="12" v-model="embedCode"></textarea>

        <button 
          type="button"
          class="code-copy__btn btn btn--prim"
          @click="clickCodeCopy"
        >
          <i
            class="material-icons material-icons-outlined code-copy__icon"
          >content_copy</i>
          {{ $t('control.widget.embed.copy_to_clipboard') }}
        </button>


      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {useStore} from "vuex";
//import {computed, onMounted} from "vue";

import {useRoute} from "vue-router";
import events from '@/helpers/widgetCustomEvent';
import {computed} from "vue";

export default {
  props: {},
  setup() {

    const store = useStore();
    const route = useRoute();

    const language_code= route.params.locale;

    const embed_server_url = process.env.VUE_APP_EMBED_URL
    const bot_id = store.state.control.botId;
    const params_from_site = store.state.control.paramsFromSite;

    const clickCodeCopy = () => {
      document.querySelector("textarea").select();
      document.execCommand('copy');
    }

   let embedCode = computed(()=>{
      let options = {
        language_code,
        bot_id,
        params_from_site,
      }

      for(let q in route.query){
        let event_data = events.getEventData(q,route.query[q])

        //if options already have sub-key like option.param={id:1} and we have another param={key:2}
        let inner_key_found = false
        for(let o in options){
          for(let e in event_data){

            if(o===e){
              if(e === 'bot_id'){
                options[o]=event_data[e]
             }else{
                options[o]={...options[o], ...event_data[e]}
              }

              inner_key_found = true;
              break;
            }
          }         
        }    

        if(!inner_key_found)options={...options,...event_data}
      }

      //remove colors if displayMode is Frame
      if(options['displayMode'] && options['displayMode'] === 'frame') {        
        delete options['colors'];
      }

      //remove multi_channel after widgetButton type changed
      if ( options['widgetButton'] && options['widgetButton'].type !== 'multi' ) {
        delete options['multi_channel']
      }

      //Timeout Mode
      const timeoutMode = Number(options['timeout_mode'])
      const timeoutValue = Number(options['timeout_value'])
      let timeoutStringStart = ''
      let timeoutStringEnd = ''

      if (timeoutMode) {
       timeoutStringStart = "setTimeout( function() { \n"
       timeoutStringEnd = `}, ${ Math.floor(timeoutValue) || 3000 }) \n`
      }
      if (timeoutValue) {
        delete options['timeout_mode']
        delete options['timeout_value']
      }
      //end Timeout Mode

     //Preview Demo
     delete options['preview_demo']
     //end Preview Demo

     //open Chat window on new message from bot
     options['open_on_msg'] = false
     //open Chat window on new message from bot

     //enable button for reload dialog
     options['btn_restart_enabled'] = false
     //open Chat window on new message from bot

      let ec = "<div id=\"kwizbot_widget\"></div>\n"
      ec+= "&gt;script defer>\n".replace('&gt;','<');
      ec+=timeoutStringStart
      ec+= "(function (k, w, i, z, b, o, t) {k['KwizbotWidget'] = b; k[b] = k[b] || function () { " +
          "w.head.insertAdjacentHTML('beforeend', '<style type=\"text/css\">.showAfterCssLoaded{display: none}</style>'); " +
          "(k[b].q = k[b].q || []).push(arguments) }, k[b].l = 1 * new Date(); o = w.createElement(i), t = w.getElementsByTagName(i)[0]; " +
          "o.async = 1; o.src = z; t.parentNode.insertBefore(o, t) " +
          "})(window, document, 'script', '"+embed_server_url+"/kwjs.js', 'kw');\n"
      ec+= "kw('init', "
      ec+=JSON.stringify(options)
      ec+= ") \n";
      ec+=timeoutStringEnd
      ec+= "&gt;/script>".replace('&gt;','<');
      return ec;

    });

    return {
      embedCode,
      clickCodeCopy,
    }
  },
};
</script>

<style lang="scss">
  .embed-code{
    font-size: 0.8em;
    border: 1px solid var(--color-periwinkle);
    background-color: var(--color-white);
    padding: 20px;
    border-radius: 3px;
  }
  .code-copy__btn {
    display: flex;
    align-items: center;
    margin-top: 10px;
  }
  .material-icons.code-copy__icon {
    font-size: 16px;
    margin-right: 10px;
  }
</style>
